import { render } from "./App.vue?vue&type=template&id=a0a2617a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a0a2617a&lang=css"

import exportComponent from "/home/davlu/Documentos/Repositorios/ProyectosWeb/luisdtorresp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__